import React from 'react'
import { Paper, Typography, makeStyles, Theme } from '@material-ui/core'

import {
    PipelineStepInstance,
    PipelineTransition,
} from './pipelineBuilder.types'
import { CARD_H, CARD_W } from './flowLayout'
import { summarizeTransitionShort } from './transitionUtils'

const useStyles = makeStyles((theme: Theme) => ({
    card: {
        width: CARD_W,
        height: CARD_H,
        minHeight: CARD_H,
        boxSizing: 'border-box',
        padding: theme.spacing(1.5, 1.75),
        cursor: 'pointer',
        border: `2px dashed ${theme.palette.primary.main}`,
        borderRadius: theme.spacing(1.5),
        backgroundColor: theme.palette.primary.main + '0a',
        transition: 'background-color 0.15s, box-shadow 0.15s',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        '&:hover': {
            backgroundColor: theme.palette.primary.main + '16',
            boxShadow: theme.shadows[1],
        },
    },
    cardSelected: {
        backgroundColor: theme.palette.primary.main + '22',
        boxShadow: theme.shadows[2],
    },
    label: {
        fontSize: '0.625rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        color: theme.palette.primary.main,
        marginBottom: theme.spacing(0.25),
    },
    summary: {
        fontSize: '0.75rem',
        lineHeight: 1.4,
        color: theme.palette.text.primary,
        overflow: 'hidden',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
    },
}))

interface FlowEdgeCardProps {
    fromStep: PipelineStepInstance
    toStep: PipelineStepInstance
    transition: PipelineTransition
    selected?: boolean
    onClick: () => void
}

export const FlowEdgeCard: React.FC<FlowEdgeCardProps> = ({
    fromStep,
    toStep,
    transition,
    selected = false,
    onClick,
}) => {
    const classes = useStyles()

    return (
        <Paper
            elevation={0}
            className={`${classes.card} ${
                selected ? classes.cardSelected : ''
            }`}
            onClick={(e) => {
                e.stopPropagation()
                onClick()
            }}
        >
            <Typography className={classes.label}>Transition</Typography>
            <Typography className={classes.summary}>
                {summarizeTransitionShort(transition, fromStep, toStep)}
            </Typography>
        </Paper>
    )
}
